import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { SpokeNameField } from './SpokeNameField';
import { validateSpokeName } from './validateSpokeName';

export const SpokeNameFieldExtension = FormFieldBlueprint.make({
  name: 'spoke-name-field',
  params: {
    field: async () =>
      createFormField({
        name: 'SpokeNameField',
        component: SpokeNameField,
        validation: (value: string | undefined, validation, context) =>
          validateSpokeName(
            value,
            validation,
            context?.formData as { region?: string } | undefined,
          ),
      }),
  },
});
